import { useMemo } from 'react';
import { useMutation } from 'react-query';
import type { MutationOptions } from 'react-query';
import ApplicationService from '../../services/applicationService';

// D5 (this card's spec): the Add flow MUST create through
// PUT .../applications/{applicationId}/applicants (applicationService.
// updateHousehold, command `updateApplicants`) -- the same route the legacy
// Edit Household page already uses (EditApplicationHousehold/sagas.js).
// Any other endpoint would silently drop the auto-reopen of a completed
// move-in certification that already lives inside that one command handler,
// plus its Affordable-Relation validation and automated-activity writes.
// applicationService.updateHousehold needs no change -- it already sends
// whatever object it's given straight through as the request body, so this
// hook only owns wrapping buildMiniProfileSavePayload's `{ adults: [...] }`/
// `{ minors: [...] }` item-array with the ids the URL/body need.
const useCreateApplicantHouseholdMemberMutation = ({
  organizationId,
  propertyId,
  applicationId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  applicationId: string,
  options: MutationOptions,
}) => {
  const applicationService = useMemo(() => new ApplicationService(), []);

  return useMutation(
    (payload) =>
      applicationService.updateHousehold(
        { id: applicationId, propertyId, ...payload },
        organizationId,
      ),
    options,
  );
};

export default useCreateApplicantHouseholdMemberMutation;
